import { render, staticRenderFns } from "./NftLock.vue?vue&type=template&id=bddacd7e&scoped=true&"
import script from "./NftLock.vue?vue&type=script&lang=js&"
export * from "./NftLock.vue?vue&type=script&lang=js&"
import style0 from "./NftLock.vue?vue&type=style&index=0&id=bddacd7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddacd7e",
  null
  
)

export default component.exports